import { render, staticRenderFns } from "./termsOfUse.vue?vue&type=template&id=61073274&scoped=true"
var script = {}
import style0 from "./termsOfUse.vue?vue&type=style&index=0&id=61073274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61073274",
  null
  
)

export default component.exports